import { ID, Action, GuidesType, HelperType, EditModeType } from "app/types/app-types"
import { Query } from 'app/types/model-types';
import { Toast } from "app/helpers/toast_factory"
import { initialGuidesState, initialHelperState } from "../shape-edit/reducers";
import { RandomProduct } from "../shape-edit/types";
import { ComparisonEngineType } from "../diagnostics/diagnostics";
import { MergadoElementsType } from "products/types";
import { FontsInProject } from "app/reducers/fonts-in-project";

export const SET_QUERIES_TO_STORE = "SET_QUERIES_TO_STORE"
export function setQueriesToStore(queries: Query[]): Action<Query[]> {
    return {
        type: SET_QUERIES_TO_STORE,
        payload: queries
    }
}

export const SET_FONTS_IN_PROJECT_TO_STORE = "SET_FONTS_IN_PROJECT_TO_STORE"
export function setFontsInProjectToStore(fontsInProject: FontsInProject): Action<FontsInProject> {
    return {
        type: SET_FONTS_IN_PROJECT_TO_STORE,
        payload: fontsInProject
    }
}

export const SET_ELEMENTS_TO_STORE = "SET_ELEMENTS_TO_STORE"
export function setElementsToStore(elements: MergadoElementsType): Action<MergadoElementsType> {
    return {
        type: SET_ELEMENTS_TO_STORE,
        payload: elements
    }
}
export const SET_LOADING_ELEMENTS_TO_STORE = "SET_LOADING_ELEMENTS_TO_STORE"
export function setIsLoadingElementsToStore(isLoading: boolean): Action<boolean> {
    return {
        type: SET_LOADING_ELEMENTS_TO_STORE,
        payload: isLoading
    }
}

export const SET_SHAPE_SETS_TO_STORE = "SET_SHAPE_SETS_TO_STORE"
export function setShapeSetsToStore(sets: any[]): Action<Query[]> {
    return {
        type: SET_SHAPE_SETS_TO_STORE,
        payload: sets
    }
}

export const CREATE_TOAST = "CREATE_TOAST"
export function createToast(toast: Toast): Action<Toast> {
    return {
        type: CREATE_TOAST,
        payload: toast
    }
}

export const REMOVE_TOAST = "REMOVE_TOAST"
export function removeToast(toastId: ID): Action<ID> {
    return {
        type: REMOVE_TOAST,
        payload: toastId,
    }
}

export const RESET_TOASTS = "RESET_TOASTS"
export function resetToasts(): Action<any> {
    return {
        type: RESET_TOASTS,
    }
}

export const SET_ACTIVE_ROUTE = "SET_ACTIVE_ROUTE"
export function setActiveRoute(route: string): Action<string> {
    return {
        type: SET_ACTIVE_ROUTE,
        payload: route,
    }
}

export const SET_RANDOM_PRODUCT = "SET_RANDOM_PRODUCT"
export function setRandomProduct(data: RandomProduct): Action<RandomProduct> {
    return {
        type: SET_RANDOM_PRODUCT,
        payload: data
    }
}

export const SET_RANDOM_PRODUCT_IS_LOADING = "SET_RANDOM_PRODUCT_IS_LOADING"
export function setRandomProductIsLoading(value: boolean): Action<boolean> {
    return {
        type: SET_RANDOM_PRODUCT_IS_LOADING,
        payload: value
    }
}

export const SET_GUIDES = "SET_GUIDES"
export function setGuides(data: GuidesType = initialGuidesState): Action<Object> {
    return {
        type: SET_GUIDES,
        payload: data
    }
}

export const SET_EDIT_MODE = 'SET_EDIT_MODE'
export function setEditMode(data: EditModeType = 'select'): Action<Object> {
    return {
        type: SET_EDIT_MODE,
        payload: data
    }
}

export const SET_SELECTED_COMPARISON_ENGINE = "SET_SELECTED_COMPARISON_ENGINE"
export function setSelectedOutputComparisonEngine(value: ComparisonEngineType = null): Action<Object> {
    return {
        type: SET_SELECTED_COMPARISON_ENGINE,
        payload: value
    }
}

export const SET_HELPER = "SET_HELPER"
export function setHelper(data: HelperType = initialHelperState): Action<Object> {
    return {
        type: SET_HELPER,
        payload: data
    }
}